interface QueueNotif {
  type: 'success' | 'error'
  message: string
}

class QueueNotifService {
  private queue: QueueNotif[] = []
  private callback: ((notif: QueueNotif) => void) | null = null
  private newVersion = false
  private newVersionCallback: ((newVersion: boolean) => void) | null = null

  public get getNewVersion() {
    return this.newVersion
  }

  public success(message: string) {
    this.add({
      type: 'success',
      message
    })
  }

  public error(message: string) {
    this.add({
      type: 'error',
      message
    })
  }

  public subscribe(callback: ((notif: QueueNotif) => void) | null) {
    this.callback = callback
    if (this.callback) {
      this.queue.forEach(this.callback)
    }
  }

  public unsubscribe() {
    this.callback = null
  }

  public hasNewVersion() {
    this.newVersion = true
    if (this.newVersionCallback) {
      this.newVersionCallback(this.newVersion)
    }
  }

  public subscribeToNewVersion(callback: (newVersion: boolean) => void) {
    this.newVersionCallback = callback
    this.newVersionCallback(this.newVersion)
  }

  private add(notif: QueueNotif) {
    this.queue.push(notif)
    if (this.callback) {
      this.queue.forEach(this.callback)
      this.queue = []
    }
  }
}

export default new QueueNotifService()
